import React, { useContext, useEffect, useState } from "react";
import { AppointmentContext } from "../context/AppointmentContext";
import { toast, ToastContainer } from "react-toastify";
import config from "../config";
import Footer from "../shared/Footer";
import Header from "../shared/Header";
import { useNavigate } from "react-router-dom";

import { PulseLoader } from "react-spinners";
import FullPageLoader from "../shared/Loader";
import { generateOneTimeToken } from "../utils/authToken";

export default function Cancelstatuspage() {
  const { hospitalName } = useContext(AppointmentContext);
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [bookingAmountInfo, setBookingAmountInfo] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [payNowLoadingId, setPayNowLoadingId] = useState(null);



  const navigate = useNavigate();


  useEffect(() => {
    const fetchAppointments = async () => {
      setLoading(true);
      setFetchError("");

      try {
        const type = hospitalName === "hazra" ? "hazra" : "newtown";
        const contact = sessionStorage.getItem("loginMobile");

        if (!contact) {
          navigate("/login");
          return;
        }

        const tokeng = generateOneTimeToken();
        const response = await fetch(

          `${config.API_BASE_URL}/VIEW_FOR_ONLINE_BOOKING_PATIENT`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" , "X-API-Key": tokeng },
            body: JSON.stringify({ TYPE: type, CONTACT: contact, STATUS: "CANCELLED" }),
          }
        );

        if (!response.ok) throw new Error("Network error");

        const respJson = await response.json();
        const apptList = respJson?.data?.appointment_details;

        if (respJson.status === 200 && Array.isArray(apptList)) {
          const mappedAppointments = apptList.map((item) => {
            const [datePart, ...timeParts] = item.DATE?.split(" ") || [];
            const timePart = timeParts.join(" ").trim();

            return {
              id: item.BOOKING_NO || "",
              date: datePart || "",
              time: timePart || "",
              doctor: item.DOCTOR_NAME || "",
              status: item.STATUS?.toUpperCase() || "PENDING",
              patient: item.PT_NAME || "",
              amount: item.AMOUNT || "",
              contact: item.PT_CONTACT || "",
              department: item.ADMISSION_DEPARTMENT_NAME || "",
              pt_code: item.PT_CODE || "",
            };
          });

          setAppointments(mappedAppointments);
        } else {
          setAppointments([]);
          setFetchError("No appointments found.");
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setFetchError("Unable to fetch appointments.");
      } finally {
        setLoading(false);
      }
    };

    fetchAppointments();
  }, [hospitalName, navigate]);

  const handleDelete = () => {
    if (!selectedAppointmentId) return;

    setAppointments((prev) => prev.filter((appt) => appt.id !== selectedAppointmentId));
    setSelectedAppointmentId(null);
    setShowModal(false);
    toast.success("Appointment cancelled.");
  };



  const closeAllDropdowns = () => {
    setOpenDropdownId(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdowns = document.querySelectorAll('[data-dropdown]');
      let insideDropdown = false;
      dropdowns.forEach((dropdown) => {
        if (dropdown.contains(event.target)) insideDropdown = true;
      });
      if (!insideDropdown) closeAllDropdowns();
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);














  const getStatusColor = (status) => {
    const colors = {
      PENDING: "bg-red-500 text-white",
      CONFIRM: "bg-green-500 text-white",
      HOLD_FOR_REFUND: "bg-red-100 text-red-800 border-red-200",
      CANCELLED: "bg-red-500 text-black"
    };
    return colors[status] || "bg-gray-100 text-gray-800 border-gray-200";
  };

  return (
    <>

      <Header />
      {loading ? (
        <FullPageLoader/>
      ) : (
        <main className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
          <ToastContainer
            position="top-right"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            className="mt-16"
          />

          <div className="container mx-auto px-4 py-2">
            {/* Header Section */}
            <div className="text-center">

              <h3 className="text-4xl md:text-4xl font-bold text-gray-800">
                <i className="fas fa-calendar-check text-blue-500"></i>&nbsp;
                Cancel Appointments
              </h3>


              <p className="text-gray-600 text-lg">
                Viewing appointments at{" "}
                <span className="font-semibold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                  {hospitalName === "hazra"
                    ? "CNCI, Hazra in Kolkata"
                    : "CNCI, New Town in Kolkata"}
                </span>
              </p>
            </div>

            {/* Main Content */}
            <div className="rounded-2xl  border border-gray-100 overflow-hidden">
              {appointments.length > 0 ? (
                <>
                  {/* Desktop Table View */}
                  <div className="hidden lg:block overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-200">
                      <thead className=" text-white sticky top-0 z-10"  style={{backgroundColor:"#467FCF"}}>
                        <tr>
                          <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider border-b border-indigo-600">Sl No.</th>
                          <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider border-b border-indigo-600">Booking ID</th>
                          <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider border-b border-indigo-600">Patient</th>
                          <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider border-b border-indigo-600">Doctor</th>
                          <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider border-b border-indigo-600">Department</th>
                          <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider border-b border-indigo-600">Date &amp; Time</th>
                          <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wider border-b border-indigo-600">Appointment Status</th>
                          <th className="px-4 py-3 text-right text-xs font-semibold uppercase tracking-wider border-b border-indigo-600">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {appointments.map((appt, index) => (
                          <tr
                            key={appt.id}
                            className={`transition-colors duration-200 cursor-pointer  hover:bg-blue-100`}
                          >
                            <td className="px-4 py-3 text-center text-sm font-medium text-gray-900">{index + 1}</td>
                            <td className="px-4 py-3 text-sm font-mono text-gray-700 rounded whitespace-nowrap">{appt.id}</td>
                            <td
                              className="px-4 py-3 max-w-[140px] truncate text-sm font-medium text-gray-900"
                              title={appt.patient}
                            >
                              {appt.patient}
                            </td>
                            <td
                              className="px-4 py-3 max-w-[140px] truncate text-sm text-gray-700"
                              title={`Dr. ${appt.doctor}`}
                            >
                              Dr. {appt.doctor}
                            </td>
                            <td
                              className="px-4 py-3 max-w-[120px] truncate text-sm text-gray-600"
                              title={appt.department}
                            >
                              {appt.department}
                            </td>
                            <td className="px-4 py-3 text-sm text-gray-900 whitespace-nowrap">
                              <div>{appt.date}</div>
                              <div className="text-gray-500 text-xs">{appt.time}</div>
                            </td>

                            <td className="px-4 py-3 text-center align-middle">
                              <div className="flex flex-col items-center gap-1">
                                <span
                                  className={`inline-block w-fit px-3 py-1 rounded-full text-xs font-semibold border ${getStatusColor(appt.status)
                                    }`}
                                >
                                  {appt.status === "HOLD_FOR_REFUND"
                                    ? "Cancel in Progress"
                                    : appt.status.replace("_", " ")}
                                </span>
                                {appt.status === "HOLD_FOR_REFUND" && (
                                  <p className="text-center text-red-600 text-xs font-semibold mt-1 max-w-[180px]">
                                    Please collect the amount from the hospital.
                                  </p>
                                )}
                              </div>
                            </td>

                            <td className="px-4 py-3 text-right text-sm font-bold text-green-600 whitespace-nowrap">
                              ₹{appt.amount}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>

                  </div>

                  {/* Mobile Card View */}
                  <div className="lg:hidden divide-y">
                    {appointments.map((appt, index) => (
                      <div
                        key={appt.id}
                        className="p-5 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-200 mb-4 cursor-pointer hover:scale-[1.02] transform"
                      >
                        <div className="flex items-start justify-between mb-4">
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-3 mb-2 flex-wrap">
                              <span className="bg-blue-100 text-blue-800 text-xs font-semibold px-2 py-1 rounded-lg select-none">
                                #{index + 1}
                              </span>

                              <div
                                className={`inline-flex flex-col items-start px-3 py-2 rounded-lg text-xs font-semibold border ${appt.status === "HOLD_FOR_REFUND"
                                  ? "border-red-400 bg-red-50 text-red-700"
                                  : getStatusColor(appt.status).replace("border-", "border-opacity-75 ") + " bg-opacity-10"
                                  }`}
                                style={{ minWidth: 120 }}
                              >
                                <span className="capitalize leading-tight whitespace-nowrap">
                                  {appt.status === "HOLD_FOR_REFUND"
                                    ? "Cancel in Progress"
                                    : appt.status.replace(/_/g, " ").toLowerCase()}
                                </span>

                                {appt.status === "HOLD_FOR_REFUND" && (
                                  <p className="mt-1 text-[10px] text-red-600 font-medium leading-tight">
                                    Please collect your money from the hospital.
                                  </p>
                                )}
                              </div>
                            </div>

                            <h3
                              className="text-lg font-semibold text-gray-900 truncate"
                              title={appt.patient}
                            >
                              {appt.patient}
                            </h3>
                            <p className="text-sm text-gray-600 truncate" title={`Dr. ${appt.doctor}`}>
                              Dr. {appt.doctor}
                            </p>
                          </div>

                          <div className="text-right min-w-[80px]">
                            <div className="text-2xl font-extrabold text-green-600 select-none">
                              ₹{appt.amount}
                            </div>
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-5 mb-4 text-sm text-gray-700">
                          <div>
                            <div className="uppercase tracking-wide font-semibold text-xs text-gray-500 mb-1">
                              Booking ID
                            </div>
                            <div
                              className="font-mono bg-gray-100 px-2 py-1 rounded text-xs truncate"
                              title={appt.id}
                            >
                              {appt.id}
                            </div>
                          </div>
                          <div>
                            <div className="uppercase tracking-wide font-semibold text-xs text-gray-500 mb-1">
                              Department
                            </div>
                            <div className="truncate" title={appt.department}>
                              {appt.department}
                            </div>
                          </div>
                          <div>
                            <div className="uppercase tracking-wide font-semibold text-xs text-gray-500 mb-1">
                              Date
                            </div>
                            <div className="font-medium truncate">{appt.date}</div>
                          </div>
                          <div>
                            <div className="uppercase tracking-wide font-semibold text-xs text-gray-500 mb-1">
                              Time
                            </div>
                            <div className="font-medium truncate">{appt.time}</div>
                          </div>
                        </div>

                        {/* Action buttons can be added here */}
                        <div className="flex flex-col sm:flex-row gap-3">
                          {/* Example button */}
                          {/* <button className="flex-1 bg-red-500 hover:bg-red-600 text-white font-semibold rounded-lg py-3 shadow transition transform hover:scale-105">
          Pay Now
        </button> */}
                        </div>
                      </div>
                    ))}
                  </div>

                </>
              ) : (
                <div className="text-center py-20">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-gray-100 rounded-full mb-6">
                    <i className="fas fa-calendar-times text-gray-400 text-3xl"></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-700 mb-2">No Appointments Found</h3>
                  <p className="text-gray-500">{fetchError || "You don't have any appointments yet."}</p>
                </div>
              )}
            </div>
          </div>

          {/* Cancel Modal */}


        </main>
      )}
      <Footer />
    </>
  );
}